import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import {
  ActionButton,
  Backdrop,
  Circle,
  CircleCheck,
  ClassSession,
} from '../../components/Themed.js';
import { getVariations } from '../../data/service/ServiceActions.js';
import { confirmClassSession } from '../../data/classes/ClassActions.js';
import './Classes.css';
import moment from 'moment-timezone';
import { t } from '../../locales';

class Classes extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedClassSessionEnrollments: [],
    };

    this.classSessionClick = this.classSessionClick.bind(this);
    this.renderClassSession = this.renderClassSession.bind(this);
    this.confirmClick = this.confirmClick.bind(this);
  }

  classSessionClick(sessionEnrollmentId) {
    if (this.state.selectedClassSessionEnrollments.indexOf(sessionEnrollmentId) > -1) {
      this.setState({
        selectedClassSessionEnrollments: this.state.selectedClassSessionEnrollments.filter(
          enrollmentId => enrollmentId !== sessionEnrollmentId
        ),
      });
    } else {
      this.setState({
        selectedClassSessionEnrollments: this.state.selectedClassSessionEnrollments.concat(
          sessionEnrollmentId
        ),
      });
    }
  }

  async confirmClick() {
    const { confirmClassSession, history, classSessionEnrollments } = this.props;
    const promises = [];

    if (classSessionEnrollments.length > 1) {
      this.state.selectedClassSessionEnrollments.forEach(selectedClassSession =>
        promises.push(confirmClassSession(selectedClassSession))
      );
    } else {
      promises.push(confirmClassSession(classSessionEnrollments[0].id));
    }

    Promise.all(promises).then(res => {
      if (res) {
        history.push('/confirmationClasses');
      }
    });
  }

  renderClassSession(classSessionEnrollment, showCheckMark) {
    const { clientInformation } = this.props;

    const selected =
      this.state.selectedClassSessionEnrollments.indexOf(classSessionEnrollment.id) > -1;

    const classIdFromSession = classSessionEnrollment.session_id
    const { location, classSessionsById } = this.props;
    const classForSession = classSessionsById[classIdFromSession]
    const description =
      classForSession.class_name +
      ' | ' +
      moment(classForSession.begin_at)
        .tz(location.time_zone)
        .format('h:mm A');
      
    let clientName = `${clientInformation.first_name} ${clientInformation.last_name}`
    // this is a child of the main client that was enrolled in the class session
    const childIdFromSession = classSessionEnrollment.my_client_child_id
    if (childIdFromSession) {
      const child = clientInformation.children && clientInformation.children.find((child) => child.id === classSessionEnrollment.my_client_child_id)
      if (child) {
        clientName = `${child.first_name} ${child.last_name}`
      }
    }

    return (
      <ClassSession
        key={classSessionEnrollment.id}
        onClick={() => this.classSessionClick(classSessionEnrollment.id)}
      >
        {showCheckMark && (
          <div
            style={{
              position: 'absolute',
              top: '0px',
              bottom: '0px',
              left: '10px',
              width: '90px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <Circle style={{ position: 'static', paddingTop: '4px' }}>
              <CircleCheck
                className="fas fa-check"
                style={{
                  opacity: selected ? 1 : 0,
                  position: 'static',
                }}
              />
            </Circle>
          </div>
        )}
        <div
          className="bookings-appointment-title"
          style={{ paddingLeft: showCheckMark ? '90px' : null }}
        >
          { clientName }
        </div>
        <div
          className="bookings-appointment-text"
          style={{ paddingLeft: showCheckMark ? '90px' : null }}
        >
          {description}
        </div>
      </ClassSession>
    );
  }

  render() {
    const { clientInformation, classSessionEnrollments } = this.props;

    if (!classSessionEnrollments || classSessionEnrollments.length === 0) {
      return (
        <React.Fragment>
          <div className="no-classes-found">{t('classes.no_classes_found')}</div>
        </React.Fragment>
      )
    }

    const firstName = clientInformation.first_name;
    const selectedCount = this.state.selectedClassSessionEnrollments.length;
    const showCheckMark = classSessionEnrollments ? classSessionEnrollments.length > 1 : false;

    return (
      <React.Fragment>
        <Backdrop id="backdrop" />
        <div className="scroll-container content-container">
          <div className="page-container">
            <div className="bookings-title">
              {t('booking.welcome')}, {firstName}!
            </div>
            <div className="content">
              {classSessionEnrollments &&
                classSessionEnrollments.map(classSessionEnrollment => this.renderClassSession(classSessionEnrollment, showCheckMark))}

              <div style={{ height: '40px' }} />
              {classSessionEnrollments && classSessionEnrollments.length === 1 && (
                <ActionButton onClick={this.confirmClick}>
                  {t('booking.check_in')}
                </ActionButton>
              )}
            </div>
          </div>
        </div>
        {classSessionEnrollments && classSessionEnrollments.length > 1 && selectedCount > 0 && (
          <div className="bookings-controls">
            <div className="bookings-controls-summary">
              {selectedCount}{' '}
              {selectedCount > 1
                ? t('booking.member_selected_plural')
                : t('booking.member_selected')}
            </div>

            <ActionButton
              onClick={this.confirmClick}
              className="bookings-controls-button"
            >
              {t('booking.continue')}
            </ActionButton>
          </div>
        )}
      </React.Fragment>
    );
  }
}

function mapStateToProps(state, ownProps) {
  return {
    location: state.app.location,
    clientInformation: state.client.clientInformation,
    classSessionEnrollments: state.classes.classSessionEnrollments,
    classSessionsById: state.classes.classSessionsById,
  };
}

export default withRouter(
  connect(
    mapStateToProps,
    {
      getVariations,
      confirmClassSession,
    }
  )(Classes)
);
